<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Detalhe da Requisição: #{{ requisicaoId }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'requisicao-lista' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-md q-gutter-sm q-ml-lg container-inputs"
    >
      <div class="col-md-1 col-lg-1 col-xs-3 input-status-container">
        <div class="titulo-inputs">Unidade</div>
        <q-input
          v-model="objetoUnidade.nome"
          bg-color="brand-7"
          class="input-font input-new-design"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md-1 col-lg-1 col-xs-3 input-status-container">
        <div class="titulo-inputs">Status</div>
        <q-input
          v-model="requisicaoDetalhes.status"
          bg-color="brand-7"
          class="input-font input-new-design"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md-3 col-lg-3 col-xs-4 input-centro-de-custo-container">
        <div class="titulo-inputs">Centro de Custo</div>
        <q-input
          class="input-font input-new-design"
          v-model="dados.centroDeCustoEunidade"
          bg-color="brand-7"
          disable
          dense
          outlined
        />
      </div>
      <div class="col-md-2 col-lg-2 col-xs-4 input-solicitante-container">
        <div class="titulo-inputs">Nome Solicitante</div>
        <q-input
          v-model="dados.solicitanteEsap"
          bg-color="brand-7"
          disable
          class="input-font input-new-design"
          dense
          outlined
        />
      </div>
      <div class="col-md-2 col-lg-2 col-xs-3 input-compra-container">
        <div class="titulo-inputs">Sol. Compra</div>
        <q-input
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          dense
          type="number"
          min="0"
          class="input-font input-new-design"
          hide-bottom-space
          outlined
          :rules="[(val) => val < 0 || 'Valor não pode ser menor que 0']"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.cliente.includes('cerradinho') ||
          $store.state.autenticacao.cliente.includes('staging-cerradinho')
        "
        class="col-md-2 col-lg-2 col-xs-3 input-compra-container"
      >
        <div class="titulo-inputs">Reserva</div>
        <q-input
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          dense
          type="number"
          v-model="dados.reserva"
          min="0"
          class="input-font input-new-design"
          disable
          bg-color="brand-7"
          hide-bottom-space
          outlined
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          icon="add"
          color="blue"
          no-caps
          label="Informações Adicionais"
          @click="rightDrawerOpen = true"
        />
      </div>
      <div class="col-md-7 col-lg-7 col-xs-7 container-input-observacao">
        <div class="q-ml-sm titulo-inputs">
          Observação
          <span class="text-caption text-grey"
            >- Clique sobre o campo para visualizar.</span
          >
        </div>

        <div class="relative-position">
          <q-input
            v-model="dados.descricao"
            bg-color="brand-7"
            disable
            class="input-font input-new-design"
            dense
            outlined
          />

          <div
            class="absolute-full cursor-help"
            @mouseover="showTooltip = true"
            @mouseleave="showTooltip = false"
            @click="abrirModalHistorico"
          ></div>

          <q-tooltip
            v-if="dados.descricao"
            v-model="showTooltip"
            class="bg-brand-1"
            anchor="bottom middle"
            :offset="[10, 10]"
            :target="`.container-input-observacao .relative-position`"
          >
            {{ dados.descricao }}
          </q-tooltip>
        </div>

        <q-dialog v-model="modalHistoricoAberto">
          <q-card class="q-pa-md" style="min-width: 300px">
            <q-card-section>
              <div class="text-h6">Histórico de Observações</div>
            </q-card-section>

            <q-card-section>
              <div v-if="dados.descricao">{{ dados.descricao }}</div>
              <div v-else class="text-grey">Nenhuma observação atual</div>

              <template v-if="historicoObservacoes.length > 0">
                <q-list bordered separator>
                  <q-item
                    v-for="(item, index) in historicoObservacoes"
                    :key="index"
                  >
                    <q-item-section>
                      <q-item-label>{{ item.data }}</q-item-label>
                      <q-item-label caption>{{ item.observacao }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </template>
            </q-card-section>

            <q-card-actions align="right">
              <q-btn flat label="Fechar" color="primary" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
      <div class="botao-imprimir">
        <router-link
          :to="{
            name: 'requisicao-imprimir',
            params: { requisicaoId: requisicaoId },
          }"
        >
          <q-btn
            style="background-color: #21324a; border-radius: 8px; color: white"
            class="q-mt-sm input-new-design"
            label="Imprimir"
            no-caps
            icon="sym_o_print"
          />
        </router-link>
      </div>
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'stock-transfer-listar-historico'
          ) != -1
        "
        class="botao-imprimir"
      >
        <router-link
          :to="{
            name: 'pkg-historico',
            params: { voucherId: requisicaoId },
          }"
        >
          <q-btn
            style="background-color: #21324a; border-radius: 8px; color: white"
            class="q-mt-sm input-new-design"
            color="brand-1"
            label="Histórico Picking"
            no-caps
            icon="history"
          />
        </router-link>
      </div>
      <div>
        <router-link
          :to="{
            name: 'requisicao-arquivos',
            params: { requisicaoId },
          }"
        >
          <q-btn
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              margin-top: 21px;
            "
            class="q-mt-sm input-new-design"
            color="secondary"
            label="Upload Arquivos"
            no-caps
            icon="note_add"
          />
        </router-link>
      </div>
      <div
        v-if="requisicaoDetalhes.status == 'Finalizado'"
        class="botao-imprimir"
      >
        <q-btn
          @click="cancelarPacialOpen = !cancelarPacialOpen"
          class="q-mt-sm"
          label="Cancelamento Parcial"
          no-caps
          color="negative"
          icon="close"
        />
      </div>
    </div>
    <div class="q-ml-lg q-mt-xl titulo-tabela">
      <div>
        <q-table
          table-header-class="bg-accent text-width-bold"
          :grid="$q.screen.lt.sm"
          :columns="columns"
          :rows="dados.produtos"
          color="primary"
          class="tabela-tamanho-fixo"
          dense
          flat
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-pagination
          hide-bottom
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Produtos Selecionados na Requisição</span
            >
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="row col-12 q-my-md">
                  <div class="col-3 q-ma-sm">
                    <div
                      v-if="props.row.product_images.length != 0"
                      class="card-img q-ml-sm"
                    >
                      <q-img
                        v-if="props.row.product_images.length != 0"
                        :src="props.row.product_images[0].url"
                        fit="contain"
                        class="img-grid"
                      />
                    </div>
                    <div class="card-img q-ml-sm" v-else>
                      <span class="img-grid"></span>
                    </div>
                  </div>
                  <div class="col text-grid-table q-pr-sm q-mt-sm">
                    <div class="row col-12 text-brand-5">
                      <span class="q-mr-sm">
                        <strong>ID: </strong> {{ props.row.code }} -
                        {{ props.row.pivot.product_id }}</span
                      >
                      <span
                        ><strong> Unidade: </strong>
                        {{ requisicaoDetalhes.vendor.name }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Solicitante: </strong>
                        {{ dados.solicitante }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Status Atual: </strong>
                        {{ requisicaoDetalhes.status }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Localizacao: </strong>
                        {{ props.row[0]?.address }}</span
                      >
                    </div>

                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Produto:</strong>
                        {{
                          props.row.contracts && props.row.contracts.length != 0
                            ? props.row?.contracts[0]?.pivot
                                ?.contract_product_description
                            : props.row.name
                        }}</span
                      >
                    </div>
                    <div
                      v-if="
                        requisicaoDetalhes.status == 'Pendente' ||
                        requisicaoDetalhes.status == 'Aprovado'
                      "
                      class="row col-12 justify-end"
                    >
                      <q-icon
                        name="manage_search"
                        style="
                          font-size: 28px;
                          margin: 0px 0px 3px 0px;
                          cursor: pointer;
                        "
                        color="black"
                        @click="
                          (item = {
                            nome: props.row.name,
                            id: props.row.code,
                          }),
                            atualizarHistorico++
                        "
                      ></q-icon>
                    </div>
                  </div>
                </div>
                <div class="row q-gutter-sm text-brand-5">
                  <div
                    v-for="(i, index) in lotes"
                    :key="index"
                    class="row q-mb-sm"
                  >
                    <div v-if="i.productId == props.row.id">
                      <div class="row items-center q-mb-sm">
                        <span class="text-campos-lotes"
                          ><strong>Lote</strong></span
                        >

                        <q-select
                          class="input-lote-nome"
                          outlined
                          dense
                          placeholder="Lote"
                          v-model="i.batch"
                          :options="
                            options(
                              props.row.id,
                              props.row.stock[0].batch_control
                            )
                          "
                          :disable="props.row.stock[0].batch_control == 0"
                          @blur="editarNomeLote(i.id, i.batch)"
                        />
                        <q-btn
                          :disable="props.row.stock[0].batch_control == 0"
                          icon="delete"
                          flat
                          dense
                          color="red"
                          class="btn-delete"
                          @click="removerLote(index)"
                        />
                      </div>
                      <div class="row items-center">
                        <span class="text-campos-lotes"
                          ><strong>Qtd</strong></span
                        >
                        <q-input
                          class="input-lote-qtd"
                          :disable="props.row.stock[0].batch_control == 0"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          outlined
                          type="number"
                          min="0"
                          dense
                          v-model="i.amount"
                          @blur="editarQuantidade(i.id, i.amount)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="q-mb-sm">
                    <div class="row items-center q-mb-sm">
                      <span class="text-campos-lotes"
                        ><strong>Lote</strong></span
                      >

                      <q-select
                        class="input-lote-nome"
                        outlined
                        dense
                        :options="options(props.row.id)"
                        v-model="props.row.batchName"
                        :disable="props.row.stock[0].batch_control == 0"
                      />
                      <q-btn
                        icon="add"
                        flat
                        dense
                        color="brand-1"
                        class="btn-delete"
                        :disable="props.row.stock[0].batch_control == 0"
                        @click="
                          adicionarLote(
                            props.row.id,
                            props.row.quantidade,
                            props.row.batchName
                          ),
                            (props.row.quantidade = 0),
                            (props.row.batchName = '')
                        "
                      />
                      <q-icon
                        v-if="props.row.lotes.length > 0"
                        style="cursor: pointer; margin: 0px 0px 0px 5px"
                        size="17px"
                        name="visibility"
                        color="brand-1"
                        @click="props.expand = !props.expand"
                      />
                    </div>
                    <div class="row items-center">
                      <span class="text-campos-lotes"
                        ><strong>Qtd</strong></span
                      >
                      <q-input
                        class="input-lote-qtd"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        outlined
                        type="number"
                        min="0"
                        :disable="props.row.stock[0].batch_control == 0"
                        dense
                        v-model="props.row.quantidade"
                      />
                    </div>
                  </div>
                  <div class="q-ml-md" v-if="props.expand">
                    <div
                      class="text-brand-5 text-weight-medium"
                      v-for="(lote, index) in props.row.lotes"
                      :key="index"
                    >
                      <div
                        class="text-lotes-existentes"
                        v-if="parseFloat(lote.amount) > 0"
                      >
                        <strong>Lote: </strong> {{ lote.batch }} |
                        <strong>Em Estoque: </strong> {{ lote.amount }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row col-12">
                  <div
                    class="row col-6 justify-center q-py-sm items-center"
                    style="background: #2d3e6e; border-radius: 0px 0px 0px 5px"
                  >
                    <div>
                      <span style="color: white; font-size: 12px">Qtd.</span>
                    </div>
                    <div class="arrow-container q-ml-sm">
                      <q-icon
                        name="arrow_left"
                        class="arrow"
                        style="background: #7e7e7e"
                      />
                    </div>
                    <div>
                      <span class="numero q-mx-sm">{{
                        props.row.pivot.amount
                      }}</span>
                    </div>
                    <div class="arrow-container">
                      <q-icon
                        name="arrow_right"
                        class="arrow"
                        style="background: #7e7e7e"
                      />
                    </div>
                  </div>
                  <div
                    class="row col-6 justify-center q-py-sm items-center"
                    style="background: #213864; border-radius: 0px 0px 5px 0px"
                  >
                    <div>
                      <span style="color: white; font-size: 12px"
                        >Entregue:</span
                      >
                    </div>
                    <div class="arrow-container q-ml-sm">
                      <q-icon
                        name="arrow_left"
                        class="arrow"
                        style="background: #fff; color: black"
                        @click="
                          props.row.pivot.new_amount != null &&
                          props.row.pivot.new_amount > 0
                            ? props.row.pivot.new_amount--
                            : ''
                        "
                      />
                    </div>
                    <div class="input-quantidade-container">
                      <q-input
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        v-model="props.row.pivot.new_amount"
                        type="number"
                        min="0"
                        borderless
                        class="input-quantidade"
                        bg-color="brand-1"
                        dense
                        :input-style="{
                          color: '#fff',
                        }"
                      />
                    </div>
                    <div class="arrow-container">
                      <q-icon
                        name="arrow_right"
                        class="arrow"
                        style="background: #6391f4"
                        @click="
                          props.row.pivot.new_amount == null
                            ? (props.row.pivot.new_amount = 1)
                            : props.row.pivot.new_amount <
                              props.row.pivot.amount
                            ? props.row.pivot.new_amount++
                            : props.row.pivot.new_amount
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #body-cell-selecionado="props">
            <q-td :props="props">
              <q-btn
                label="Selecionado"
                color="accent"
                dense
                no-caps
                text-color="black"
                disable
                icon="check_circle_outline"
              />
            </q-td>
          </template>
          <template #body-cell-imagem="props">
            <q-td :props="props">
              <div
                v-if="props.row.product_images.length != 0"
                class="img-container"
              >
                <q-img
                  v-if="props.row.product_images.length != 0"
                  :src="props.row.product_images[0].url"
                  fit="contain"
                  style="max-width: 100%; height: 45px"
                />
              </div>
              <div class="img-container" v-else>
                <span class="img-normal"></span>
              </div>
            </q-td>
          </template>
          <template #body-cell-codigo="props">
            <q-td :props="props">
              <div>{{ props.row.code }} - {{ props.row.pivot.product_id }}</div>
            </q-td>
          </template>
          <template #body-cell-nome="props">
            <q-td :props="props">
              <div>
                {{
                  props.row.contracts && props.row.contracts.length != 0
                    ? props.row?.contracts[0]?.pivot
                        ?.contract_product_description
                    : props.row.name
                }}

                <q-btn
                  v-if="
                    requisicaoDetalhes.status == 'Finalizado' &&
                    props.row?.pivot?.amount != 0
                  "
                  icon="refresh"
                  flat
                  color="brand-1"
                  @click="
                    (grupoIdTroca =
                      props.row?.contracts[0]?.pivot?.product_group_id ||
                      props.row.id),
                      (trocarItemModal = true),
                      (produtoIdTroca = props.row)
                  "
                />
              </div>
            </q-td>
          </template>
          <template #body-cell-estoque="props">
            <q-td :props="props">
              {{ retornarValorEstoque(props.row.stock) }}
            </q-td>
          </template>
          <template #body-cell-localizacao="props">
            <q-td :props="props">
              {{ props.row?.stock[0]?.address }}
            </q-td>
          </template>

          <template #body-cell-quantidade="props">
            <q-td :props="props">
              <q-input
                v-model="props.row.pivot.amount"
                outlined
                disable
                bg-color="brand-7"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                dense
                min="0"
                type="number"
                style="width: 100px"
              />
            </q-td>
          </template>
          <template #body-cell-quantidadeEntregue="props">
            <q-td :props="props">
              <!--eslint-disable-next-line-->
              <q-input
                outlined
                dense
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
                style="max-width: 100px"
                :class="
                  Number(props.row.pivot.new_amount) >
                  Number(props.row.pivot.amount)
                    ? 'quantidade-input-requisicao'
                    : ''
                "
                min="0"
                type="number"
                :max="props.row.pivot.amount"
                v-model="props.row.pivot.new_amount"
                :disable="
                  requisicaoDetalhes.status == 'Finalizado' ||
                  requisicaoDetalhes.status == 'Cancelado'
                "
              >
                <!--eslint-disable-next-line-->
                <q-tooltip
                  no-parent-event
                  :model-value="
                    Number(props.row.pivot.new_amount) >
                    Number(props.row.pivot.amount)
                  "
                  class="bg-negative"
                  anchor="top middle"
                  self="bottom middle"
                  :offset="[10, 10]"
                >
                  Quantidade digitada muito acima
                </q-tooltip>
              </q-input>
            </q-td>
          </template>
          <template #body-cell-lote="props">
            <q-td :props="props">
              <div style="width: 360px">
                <div
                  v-for="(lote, index) in lotes"
                  :key="index"
                  class="row q-gutter-sm"
                  style="width: 380px; margin-top: 2px"
                >
                  <div
                    v-if="lote.productId == props.row.id"
                    class="row q-gutter-sm"
                    style="margin: 0px"
                  >
                    <q-select
                      type="text"
                      outlined
                      dense
                      placeholder="Lote"
                      class="q-mb-sm"
                      style="width: 180px"
                      v-model="lote.batch"
                      :options="
                        options(props.row.id, props.row.stock[0].batch_control)
                      "
                      :disable="props.row.stock[0].batch_control == 0"
                      @blur="editarNomeLote(lote.id, lote.batch)"
                    />
                    <q-input
                      :disable="props.row.stock[0].batch_control == 0"
                      outlined
                      dense
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      style="width: 120px"
                      min="0"
                      type="number"
                      v-model="lote.amount"
                      @blur="editarQuantidade(lote.id, lote.amount)"
                    />
                    <q-btn
                      :disable="props.row.stock[0].batch_control == 0"
                      style="padding: 0px"
                      icon="delete"
                      flat
                      color="red"
                      @click="removerLote(index)"
                    />
                  </div>
                </div>
                <div
                  class="row q-gutter-sm"
                  style="width: 360px; margin-top: 5px"
                >
                  <q-select
                    :options="options(props.row.id)"
                    v-model="props.row.batchName"
                    :disable="props.row.stock[0].batch_control == 0"
                    outlined
                    dense
                    style="width: 180px"
                  />
                  <q-input
                    :disable="props.row.stock[0].batch_control == 0"
                    outlined
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    dense
                    min="0"
                    type="number"
                    style="width: 120px"
                    v-model="props.row.quantidade"
                  />
                  <q-btn
                    :disable="props.row.stock[0].batch_control == 0"
                    style="padding: 0px"
                    color="brand-1"
                    dense
                    no-caps
                    icon="add"
                    flat
                    @click="
                      adicionarLote(
                        props.row.id,
                        props.row.quantidade,
                        props.row.batchName
                      ),
                        (props.row.quantidade = 0),
                        (props.row.batchName = '')
                    "
                  />
                  <q-icon
                    v-if="props.row.lotes.length > 0"
                    style="cursor: pointer; margin: 0px 0px 0px 5px"
                    size="17px"
                    name="visibility"
                    color="brand-1"
                    @click="props.expand = !props.expand"
                  />
                </div>
              </div>
              <div v-if="props.expand">
                <div
                  class="text-brand-5 text-weight-medium"
                  v-for="(lote, index) in props.row.lotes"
                  :key="index"
                >
                  <span v-if="parseFloat(lote.amount) > 0"
                    ><strong>Lote: </strong> {{ lote.batch }} |
                    <strong>Em Estoque: </strong> {{ lote.amount }}</span
                  >
                </div>
              </div>
            </q-td>
          </template>
          <template #body-cell-retiradas="props">
            <q-td :props="props">
              <q-btn
                icon="manage_search"
                flat
                round
                color="black"
                :disable="
                  requisicaoDetalhes.status != 'Pendente' &&
                  requisicaoDetalhes.status != 'Aprovado'
                "
                @click="
                  (item = { nome: props.row.name, id: props.row.code }),
                    atualizarHistorico++
                "
              />
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <div class="q-ml-lg q-mt-xl titulo-tabela">
      <div>
        <q-table
          table-header-class="bg-accent text-width-bold"
          :columns="columns2"
          :loading="loading"
          class="tabela-tamanho-fixo"
          :grid="$q.screen.lt.sm"
          :rows="dados.historico"
          dense
          :rows-per-page-options="[0]"
          color="primary"
          flat
          hide-pagination
          hide-bottom
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Histórico da Requisição</span
            >
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="row col-12 q-my-md">
                  <div class="col-9 text-grid-table q-pa-sm">
                    <div class="row col-12 text-brand-5">
                      <span class="q-mr-sm">
                        <strong>Ação: </strong> {{ props.row.name }}
                      </span>
                      <span
                        ><strong> Data: </strong>
                        {{
                          props.row.pivot.created_at
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Solicitante: </strong>
                        {{ dados.solicitante }}</span
                      >
                    </div>
                    <div class="row col-12 text-brand-5">
                      <span
                        ><strong>Observação: </strong>
                        {{ props.row.pivot.comment }}</span
                      >
                    </div>
                  </div>
                  <div class="col text-grid-table text-brand-5">
                    <div><strong>Assinatura:</strong></div>
                    <div class="q-ml-sm q-mt-sm">
                      <q-img
                        v-if="
                          props.row.pivot.auth_type != 'token' &&
                          props.row.pivot.auth_type != null
                        "
                        :src="props.row.pivot.auth_content"
                        fit="contain"
                        style="max-width: 40px; height: 5z5px"
                      />
                      <div v-else style="font-size: 10px">
                        {{ "Assinatura Eletrônica" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #body-cell-acao="props">
            <q-td :props="props">
              <div>
                {{ props.row.name }}
              </div>
            </q-td>
          </template>
          <template #body-cell-nome="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.user.name }}</div>
            </q-td>
          </template>
          <template #body-cell-observacao="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.comment }}</div>
            </q-td>
          </template>
          <template #body-cell-data="props">
            <q-td :props="props">
              <div>
                {{
                  props.row.pivot.created_at
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
                <p style="margin: 0 0 0 0px">
                  {{ props.row.pivot.created_at.split(" ")[1] }}
                </p>
              </div>
            </q-td>
          </template>
          <template #body-cell-tipoAutenticacao="props">
            <q-td :props="props">
              <div>{{ props.row.pivot.auth_type }}</div>
            </q-td>
          </template>
          <template #body-cell-autenticacao="props">
            <q-td :props="props">
              <q-img
                v-if="
                  props.row.pivot.auth_type != 'token' &&
                  props.row.pivot.auth_type != null
                "
                :src="props.row.pivot.auth_content"
                fit="contain"
                style="max-width: 40px; height: 5z5px"
              />
              <div v-else>
                {{ "Assinatura Eletrônica" }}
              </div>
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <div
      v-if="requisicaoDetalhes.status == 'Aprovado'"
      class="col-12 q-ml-lg q-mt-xl container-assinatura-responsiva"
    >
      <div class="text-brand-5 text-weight-bold q-mb-sm">
        Tipo de Assinatura
      </div>
      <div class="text-brand-5 text-weight-bold q-mt-sm">
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('staging-vale') &&
            !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-assinatura'
            ) != -1
          "
          label="Assinatura"
          val="assinatura"
          v-model="tipoAssinatura"
        />
        <q-radio
          v-if="
            !mobile &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-biometria'
            ) != -1
          "
          label="Biometria"
          val="biometria"
          v-model="tipoAssinatura"
        />
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('staging-acciona') &&
            !$store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-pin'
            ) != -1
          "
          v-model="tipoAssinatura"
          label="PIN"
          val="web_pin"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-token'
            ) != -1
          "
          v-model="tipoAssinatura"
          label="Token"
          val="token"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'vouchers-auth-facial'
            ) != -1
          "
          v-model="tipoAssinatura"
          label="Facial"
          val="facial"
          :size="mobile ? 'sm' : 'lg'"
        />
        <div
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-pin'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-biometria'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-assinatura'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-auth-token'
            ) == -1 &&
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'vouchers-auth-facial'
            ) == -1
          "
          class="q-my-md"
        >
          <span
            >Você não possui nenhum método de autenticação associado ao seu
            usuário, entre em contato com o suporte.</span
          >
        </div>
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
        v-if="
          tipoAssinatura === 'web_pin' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-pin'
          ) != -1
        "
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>
      <div
        v-if="
          tipoAssinatura == 'assinatura' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-assinatura'
          ) != -1
        "
        class="row col-12 q-mt-md canvas-container"
      >
        <Canvas @update="recebeAssinatura" :go="salvarAssinatura" />
      </div>
      <div
        v-if="
          tipoAssinatura == 'biometria' &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'voucher-auth-biometria'
          ) != -1
        "
      >
        <div class="q-mt-md" v-if="requisicaoDetalhes.plantiff?.biometry">
          <q-img
            v-if="usuarioVerificado"
            class="imagem-biometria"
            src="../../../assets/bioOK.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../assets/bioRequest.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria, após
            leitura, clique em CONFIRMAR ENTREGA</span
          >
          <Biometria
            :modal="verificarBiometria"
            :userId="dados.solicitanteId"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="recebeBiometria"
            @resultadoVerificacao="receberResultadoBiometria"
          />
        </div>

        <div class="q-mt-md" v-else>
          <q-img
            class="imagem-biometria"
            src="../../../assets/bioNO.png"
            @click="verificarBiometria = !verificarBiometria"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 14px"
            >O funcionário não possui biometria cadastrada, favor clicar no
            icone e realizar o procedimento de cadastro antes da finalização da
            requisição</span
          >
          <Biometria
            :modal="verificarBiometria"
            :userId="dados.solicitanteId"
            :titulo="'Cadastro de Biometria'"
            :tipoBiometria="'cadastro'"
            @atualizarBiometrias="atualizarTemplatesBiometria"
          />
        </div>
      </div>
    </div>
    <div
      @click="facial = true"
      style="cursor: pointer"
      class="q-ml-lg q-mt-md"
      v-if="tipoAssinatura == 'facial'"
    >
      <div class="relative-position" style="display: inline-block">
        <q-icon
          v-if="requisicaoDetalhes.plantiff?.biometria_facial"
          size="60px"
          class="q-mr-xs"
          name="face"
          :color="imagemBase64 == null ? 'yellow' : 'positive'"
        />
        <q-icon
          v-else
          size="60px"
          class="q-mr-xs"
          name="face"
          color="negative"
        />

        <q-icon
          v-if="requisicaoDetalhes.plantiff?.biometria_facial"
          :name="imagemBase64 == null ? 'schedule' : 'check_circle'"
          :style="{
            color: imagemBase64 == null ? '#ffea00' : '#2E7D32',
          }"
          size="22px"
          class="absolute-bottom-right"
          style="bottom: 2px; right: -2px; z-index: 0"
        >
          <q-tooltip
            anchor="top middle"
            self="bottom middle"
            :class="
              imagemBase64 == null ? 'bg-gray text-white' : 'bg-gray text-white'
            "
          >
            {{
              imagemBase64 == null
                ? "Aguardando captura da face"
                : "Face capturada com sucesso"
            }}
          </q-tooltip>
        </q-icon>
        <q-icon
          v-else
          name="cancel"
          style="color: #c62828; bottom: 2px; right: -2px; z-index: 0"
          size="22px"
          class="absolute-bottom-right"
        >
          <q-tooltip
            anchor="top middle"
            self="bottom middle"
            class="bg-gray text-white"
          >
            Face não cadastrada
          </q-tooltip>
        </q-icon>
      </div>

      <span
        v-if="requisicaoDetalhes.plantiff?.biometria_facial"
        class="q-ml-sm text-bold text-brand-5"
        style="font-size: 16px"
      >
        Clique no ícone da face para reconhecimento, após leitura, clique em
        CONFIRMAR ENTREGA
      </span>

      <span
        v-else
        class="q-ml-sm text-bold text-brand-5"
        style="font-size: 14px"
      >
        O funcionário não possui face cadastrada, favor clicar no ícone e
        realizar o procedimento de cadastro antes da finalização da requisição
      </span>

      <!-- Modal de verificação (quando usuário JÁ TEM facial cadastrada) -->
      <VerificacaoFacial
        v-if="requisicaoDetalhes.plantiff?.biometria_facial && facial"
        :userId="dados.solicitanteId"
        v-model="facial"
        @close="fecharFacial"
        @sendFace="receberFace"
      />

      <!-- Modal de cadastro (quando usuário NÃO TEM facial cadastrada) -->
      <VerificacaoFacial
        v-if="!requisicaoDetalhes.plantiff?.biometria_facial && facial"
        :userId="dados.solicitanteId"
        v-model="facial"
        :tipoCadastro="true"
        @close="fecharFacial"
        @sendFace="receberFaceCadastro"
        @atualizarFacial="atualizarTemplatesFacial"
      />
    </div>

    <div
      v-if="requisicaoDetalhes.status == 'Aprovado'"
      class="q-ml-lg q-mt-xl titulo-tabela"
    >
      <div
        class="text-h6 text-brand-5 text-weight-bold q-mb-lg texto-titulo-tabela"
      >
        Selecione o usuário que retirou -
        {{
          dados.solicitante && dados.solicitante.name
            ? dados.solicitante.name
            : dados.solicitante
        }}
      </div>
      <div class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold">
        <div
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'ordem-servico-detalhar'
            ) != -1
          "
          class="col-md-3 col-xs col-sm"
        >
          <div class="q-ml-sm">Selecione o Usuário</div>
          <q-select
            v-model="dados.solicitante"
            :options="listaSolicitante"
            outlined
            dense
            label="Selecione o Usuário"
            @filter="filterSolicitante"
            use-input
            hide-selected
            fill-input
            option-value="id"
            option-label="name"
            input-debounce="500"
          >
          </q-select>
        </div>
        <div class="col-md-3 col-xs col-sm">
          <div class="q-ml-sm">Data Retirada</div>
          <q-input
            class="input"
            v-model="dados.dataRetroativa"
            dense
            outlined
            placeholder="Data de Retirada"
            :disable="requisicaoDetalhes.status == 'Finalizado'"
            mask="##/##/####"
            :error="dataRetroativaErro !== ''"
            :error-message="dataRetroativaErro"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dados.dataRetroativa"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :options="dataPermitida"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>
    </div>

    <div
      class="row container-observacao-row q-mt-xl text-brand-5 text-weight-bold text-body q-ml-lg"
    >
      <div
        class="observacao-container"
        v-if="requisicaoDetalhes.status != 'Finalizado'"
      >
        <div class="q-ml-sm titulo-pagina-principal q-mb-sm">
          <span class="text-brand-1">Mensagem para a Aprovação desta Fase</span>
          <span class="sub-text q-ml-sm text-greey"
            >(Máximo 255 caracteres)</span
          >
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          placeholder="Deixe uma mensagem para a aprovação desta etapa."
          v-model="mensagemFase"
        />
      </div>

      <div class="row col-12 q-gutter-xs q-mt-md">
        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="
            requisicaoDetalhes.status == 'Aprovado' ||
            requisicaoDetalhes.status == 'Pendente'
          "
        >
          <q-btn
            class="btn"
            :label="
              requisicaoDetalhes.status == 'Pendente'
                ? 'Aprovar Requisição'
                : 'Finalizar Requisição'
            "
            no-caps
            :disable="
              dados.produtos?.filter((value) => {
                return Number(value.pivot.new_amount) > value.pivot.amount;
              }).length != 0 ||
              botaoFinalizacao ||
              dataRetroativaErro !== ''
            "
            color="positive"
            icon="sym_o_done"
            style="
              border-radius: 8px;

              font-weight: normal;
            "
            @click="
              requisicaoDetalhes.status == 'Pendente'
                ? aprovar()
                : tipoFinalizacao()
            "
          />
        </div>

        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="requisicaoDetalhes.status == 'Pendente'"
        >
          <q-btn
            class="btn"
            label="Reprovar Requisição"
            no-caps
            style="
              border-radius: 8px;

              font-weight: normal;
            "
            color="negative"
            icon="sym_o_close"
            @click="reprovarRequisicao()"
          />
        </div>
        <div
          class="col-md-2 col-xs-5 col-sm-5"
          v-if="
            requisicaoDetalhes.status == 'Aprovado' ||
            requisicaoDetalhes.status == 'Pendente'
          "
        >
          <q-btn
            label="Atualizar Quantidade"
            no-caps
            style="
              border-radius: 8px;

              font-weight: normal;
            "
            class="btn"
            color="primary"
            icon="sync"
            :disable="
              dados.produtos?.filter((value) => {
                return Number(value.pivot.new_amount) > value.pivot.amount;
              }).length != 0 ||
              $store.state.autenticacao.cliente.includes(
                'staging-cerradinho'
              ) ||
              $store.state.autenticacao.cliente.includes('cerradinho')
            "
            @click="atualizarValores()"
          />
        </div>
      </div>
    </div>
    <TabelaHistoricoRetirada
      :solicitanteId="dados?.sap"
      :item="item"
      :atualizar="atualizarHistorico"
    />
    <TrocarProdutos
      :rightDrawerOpen="trocarItemModal"
      @fecharModal="trocarItemModal = false"
      :nomeModal="'Trocar Item'"
    >
      <template v-slot:conteudo-modal>
        <q-spinner
          color="primary"
          size="5em"
          :thickness="10"
          class="q-pa-md"
          v-if="loading"
        />
        <div
          v-else-if="!loading && grupoTrocaList.length === 0"
          class="q-pa-lg text-center"
        >
          <q-icon name="info" size="60px" color="grey-6" class="q-mb-md" />
          <div class="text-h6 text-grey-7 q-mb-md">
            Não existe produtos para realizar a troca.
          </div>
        </div>
        <div
          v-else
          class="col-md-12 col-lg-12 col-xs-12 input-compra-container"
        >
          <section
            style="font-size: 13px; border: solid 1px black; border-radius: 5px"
            class="row q-mb-sm align"
            v-for="(produto, index) in grupoTrocaList"
            :key="index"
          >
            <q-radio size="sm" v-model="selectedTrocaProduto" :val="produto" />
            <span
              style="
                width: 70px;
                font-weight: bold;
                text-overflow: ellipsis;
                overflow: hidden;
              "
              >{{ produto.code }}
              <q-tooltip
                class="bg-brand-1"
                anchor="top middle"
                self="bottom middle"
                :offset="[10, 10]"
              >
                {{ produto.code }}
              </q-tooltip>
            </span>
            <span class="q-mr-sm">x</span>
            <span
              style="
                width: 350px;
                font-weight: bold;
                text-overflow: ellipsis;
                overflow: hidden;
              "
              >{{ produto.name }}
              <q-tooltip
                class="bg-brand-1"
                anchor="top middle"
                self="bottom middle"
                :offset="[10, 10]"
              >
                {{ produto.name }}
              </q-tooltip>
            </span>

            <span class="q-ml-sm q-mr-sm">{{
              parseInt(produto?.stock[0]?.pivot?.amount)
            }}</span>
          </section>
        </div>
      </template>
    </TrocarProdutos>

    <CancelarParcial
      :rightDrawerOpen="cancelarPacialOpen"
      @fecharModal="cancelarPacialOpen = false"
      :nomeModal="'Cancelamento Parcial'"
    >
      <template v-slot:conteudo-modal>
        <q-spinner
          color="primary"
          size="5em"
          :thickness="10"
          class="q-pa-md"
          v-if="dados.produtos.length == 0"
        />

        <div
          v-else
          style="max-height: 555px; overflow-y: auto; overflow-x: hidden"
        >
          <q-table
            flat
            bordered
            dense
            :rows="dados.produtos"
            :columns="columnsCancelarParcial"
            row-key="id"
            table-class="custom-table"
          >
            <template v-slot:body-cell-selecionar="props">
              <q-td :props="props">
                <q-checkbox
                  v-model="selectedTrocaProdutoCancelarParcial"
                  :val="props.row.id"
                  :disable="parseInt(props.row?.pivot?.amount) === 0"
                />
              </q-td>
            </template>

            <template v-slot:body-cell-code="props">
              <q-td :props="props">
                {{ props.row.code }}
                <q-tooltip class="bg-brand-1">
                  {{ props.row.code }}
                </q-tooltip>
              </q-td>
            </template>

            <template v-slot:body-cell-name="props">
              <q-td :props="props">
                {{ props.row.name.slice(0, 36)
                }}{{ props.row.name.length > 36 ? "..." : "" }}
                <q-tooltip class="bg-brand-1">
                  {{ props.row.name }}
                </q-tooltip>
              </q-td>
            </template>

            <template v-slot:body-cell-amount="props">
              <q-td :props="props" class="text-right">
                {{ parseInt(props.row?.pivot?.amount) }}
              </q-td>
            </template>
          </q-table>
        </div>
      </template>

      <template v-slot:botao-modal>
        <q-btn
          @click="
            confirmacaoCanelamentoParcial = !confirmacaoCanelamentoParcial
          "
          class="q-mt-sm"
          label="Confirmar"
          no-caps
          :disable="selectedTrocaProdutoCancelarParcial.length == 0"
          color="positive"
          icon="done"
        />
      </template>
    </CancelarParcial>

    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Informações Adicionais'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div
          v-if="
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'ordem-servico-detalhar'
            ) != -1
          "
          class="col-md-12 col-lg-12 col-xs-12 input-compra-container"
        >
          <div>Ordem de Serviço</div>
          <q-select
            v-model="dados.ordem"
            :options="listaOrdem"
            :disable="requisicaoDetalhes.status == 'Finalizado'"
            outlined
            dense
            label="Selecione a Ordem"
            @filter="filterOrdem"
            use-input
            hide-selected
            fill-input
            option-label="numero"
            input-debounce="500"
          >
            <template v-if="dados.ordem" v-slot:append>
              <q-icon
                name="close"
                @click="removerOrdem"
                class="cursor-pointer"
                color="negative"
              />
            </template>
          </q-select>
        </div>
        <div
          v-if="
            $store.state.autenticacao.cliente.indexOf('acciona') != -1 ||
            $store.state.autenticacao.cliente.indexOf('staging-acciona') != -1
          "
          class="col-12 q-mt-sm"
        >
          <div>Unidade de Destino</div>
          <SelecaoUnidade
            :model="unidadeTransferencia"
            @enviarUnidade="receberUnidadeTransferencia"
          />
        </div>
      </template>
      <template v-slot:botao-modal>
        <div class="row col-12 q-gutter-sm">
          <q-btn
            no-caps
            label="Salvar"
            class="btn-modal"
            icon="save"
            color="primary"
            @click="rightDrawerOpen = false"
          />
          <q-btn
            v-if="
              $store.state.autenticacao.cliente.indexOf('acciona') != -1 ||
              $store.state.autenticacao.cliente.indexOf('staging-acciona') != -1
            "
            no-caps
            label="Criar Transferencia"
            icon="done"
            class="btn-modal"
            color="positive"
            @click="confirm = true"
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA CRIAR A TRANSFERÊNCIA?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Sim"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="criarTransferencia()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen || trocarItemModal"
      @click="(rightDrawerOpen = false), (trocarItemModal = false)"
      class="mascara"
    ></div>

    <dialog-confirm
      :mensagem="
        'Você tem certeza que deseja trocar o item ' +
        produtoIdTroca?.description +
        ' ' +
        'pelo' +
        ' ' +
        selectedTrocaProduto?.name +
        '?'
      "
      :exibir="confirmacao"
      @resultado="enviar"
    >
    </dialog-confirm>

    <dialog-confirm
      mensagem="
        Você tem certeza que deseja continuar?
      "
      :exibir="confirmacaoCanelamentoParcial"
      @resultado="enviarCancelamentoPacial"
    >
    </dialog-confirm>

    <!-- Componentes VerificacaoFacial condicionais integrados na seção facial -->
  </q-page>
</template>

<script>
import { onMounted, watch, computed } from "@vue/runtime-core";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import VerificacaoFacial from "../components/VerificacaoFacial.vue";
import TrocarProdutos from "../components/TrocarProdutos.vue";
import CancelarParcial from "../components/CancelarParcial.vue";
import Canvas from "../components/Canvas.vue";
import DialogConfirm from "../components/DialogConfirm.vue";
import SelecaoUnidade from "../../ferramentaria/components/SelecaoUnidade.vue";
import Biometria from "../../biometria/views/Biometria.vue";
import TabelaHistoricoRetirada from "../components/TabelaHistoricoRetirada.vue";
import ModalInformacaoesAdicionais from "../components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "selecionado",
    label: "Produtos Selecionados",
    align: "center",
    sortable: false,
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
  },
  {
    name: "localizacao",
    label: "Localização",
    field: (row) => row?.stock[0]?.address,
    align: "left",
    sortable: false,
  },
  {
    name: "grupoProduto",
    label: "Grupo de Produto",
    align: "left",
    field: (row) => row.grupoProduto,
    sortable: false,
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
  },
  {
    name: "quantidadeEntregue",
    label: "Quantidade Entregue",
    align: "left",
    sortable: false,
  },
  {
    name: "lote",
    label: "Lote",
    align: "left",
  },
  {
    name: "retiradas",
    label: "Retiradas",
    align: "left",
  },
];
const columns2 = [
  {
    name: "acao",
    label: "Ação",
    align: "center",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome Requisitante",
    align: "left",
    sortable: false,
  },
  {
    name: "observacao",
    label: "Observação",
    align: "left",
    sortable: false,
  },
  {
    name: "data",
    label: "Data",
    align: "center",
    sortable: false,
  },
  {
    name: "tipoAutenticacao",
    label: "Tipo de Autenticação",
    align: "left",
    sortable: false,
  },
  {
    name: "autenticacao",
    label: "Autenticação",
    align: "left",
    sortable: false,
  },
];
export default {
  components: {
    Canvas,
    Biometria,
    TabelaHistoricoRetirada,
    ModalInformacaoesAdicionais,
    TrocarProdutos,
    SelecaoUnidade,
    VerificacaoFacial,
    DialogConfirm,
    CancelarParcial,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();
    const facial = ref(false);
    const confirm = ref(false);
    const informarDataRetroativa = ref(false);
    const requisicaoId = route.params.requisicaoId;
    const rightDrawerOpen = ref(false);
    const requisicaoDetalhes = ref([]);
    const assinaturaDesabilitado = ref(["staging-vale", "vale"]);
    const assinaturaDesabilitadoVariable = ref(true);
    const trocarItemModal = ref(false);
    const cancelarPacialOpen = ref(false);
    const grupoIdTroca = ref(null);
    const produtoIdTroca = ref(null);
    const selectedTrocaProduto = ref(null);
    const selectedTrocaProdutoCancelarParcial = ref([]);
    const showTooltip = ref(false);
    const modalHistoricoAberto = ref(false);
    const historicoObservacoes = ref([]);

    const columnsCancelarParcial = [
      {
        name: "selecionar",
        label: "",
        align: "left",
        field: "selecionar",
      },
      {
        name: "code",
        label: "Código",
        align: "left",
        field: "code",
      },
      {
        name: "name",
        label: "Descrição",
        align: "left",
        field: "name",
      },
      {
        name: "amount",
        label: "QTD",
        align: "right",
        field: (row) => parseInt(row?.pivot?.amount),
      },
    ];
    const confirmacaoCanelamentoParcial = ref(false);
    const grupoTrocaList = ref([]);
    const confirmacao = ref(false);
    let loading = ref(false);
    const dados = ref({
      centroDeCusto: "",
      solicitante: "",
      solicitanteEsap: "",
      centroDeCustoEunidade: "",
      solicitanteId: "",
      descricao: "",
      produtos: [],
      historico: [],
      ordem: null,
      reserva: "",
      dataRetroativa: null,
    });
    const tipoAssinatura = ref("assinatura");
    const userLogadoQuery = computed(() => route.query.userLogado == "true");
    const unidadeTransferencia = ref("");
    const description = ref("");
    let imagemBase64 = ref(null);
    const mensagemFase = ref(undefined);
    const userLogadoId = ref("");
    let salvarAssinatura = ref(0);
    const lotes = ref([]);
    const batchsName = ref("");
    const batchsQuantidade = ref(0);
    const nextId = ref(0);
    let uploadArquivo = ref(false);
    let verificarBiometria = ref(false);
    const pin = ref("");
    let usuarioVerificado = ref(false);
    const atualizarHistorico = ref(0);
    let mobile = ref(false);
    const item = ref({ nome: "", id: "" });
    const objetoUnidade = ref({
      nome: "",
      id: "",
    });
    const time = ref(null);
    const listaOrdem = ref([]);
    const listaSolicitante = ref([]);
    if (quasar.platform.is.mobile) {
      mobile = ref(true);
      dados.value.tipoAutenticacao = "web_pin";
    }
    const botaoFinalizacao = ref(false);
    const dataRetroativaErro = ref("");

    const validateDataRetroativa = (valor) => {
      if (!valor || valor.length < 10) {
        dataRetroativaErro.value = "";
        return;
      }

      const partes = valor.split("/");
      if (partes.length !== 3) {
        dataRetroativaErro.value =
          "Data de retirada inválida, informe a data corretamente";
        return;
      }

      const dia = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10);
      const ano = parseInt(partes[2], 10);

      const dataObjeto = new Date(ano, mes - 1, dia);
      const isValida =
        !isNaN(dataObjeto.getTime()) &&
        dataObjeto.getFullYear() === ano &&
        dataObjeto.getMonth() === mes - 1 &&
        dataObjeto.getDate() === dia;

      if (!isValida) {
        dataRetroativaErro.value =
          "Data de retirada inválida, informe a data corretamente";
        return;
      }

      const dataMinima = new Date(2000, 0, 1);
      if (dataObjeto < dataMinima) {
        dataRetroativaErro.value =
          "Data de retirada inválida, informe a data corretamente";
        return;
      }

      const hoje = new Date();
      hoje.setHours(23, 59, 59, 999);
      if (dataObjeto > hoje) {
        dataRetroativaErro.value =
          "A data de retirada não pode ser maior que a data atual";
        return;
      }

      dataRetroativaErro.value = "";
    };

    const detalheRequisicao = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      lotes.value = [];
      loading.value = true;
      try {
        dados.value.dataRetroativa = formatarDataAtual();

        let response = await store.dispatch(
          userLogadoQuery.value
            ? "requisicao/detalharVoucherUserLogado"
            : "requisicao/detalharVoucher",
          {
            voucher_id: requisicaoId,
          }
        );
        requisicaoDetalhes.value = response.data.model;

        objetoUnidade.value = {
          nome: requisicaoDetalhes.value?.vendor?.name,
          id: requisicaoDetalhes.value?.vendor?.id,
        };
        dados.value.centroDeCusto = requisicaoDetalhes.value.cost_center?.name;
        dados.value.solicitante = requisicaoDetalhes.value.plantiff?.name;
        dados.value.solicitanteId = requisicaoDetalhes.value.plantiff?.id;
        dados.value.sap = requisicaoDetalhes.value.plantiff?.sap;
        dados.value.solicitanteEsap = `${requisicaoDetalhes.value.plantiff?.name} - ${requisicaoDetalhes.value.plantiff?.sap}`;
        dados.value.centroDeCustoEunidade = `${requisicaoDetalhes.value.cost_center?.name} - ${requisicaoDetalhes.value.cost_center?.vendor?.name} `;
        dados.value.descricao = requisicaoDetalhes.value.description;
        dados.value.produtos = requisicaoDetalhes.value.products;
        dados.value.historico = requisicaoDetalhes.value.applications;
        dados.value.ordem = requisicaoDetalhes.value.os;
        dados.value.reserva =
          requisicaoDetalhes.value?.products[0]?.reserva_sap;
        dados.value.produtos.forEach((e) => {
          e.lotes.sort((a, b) => {
            if (a.expiration_date == null || b.expiration_date == null) {
              if (a.expiration_date == null) {
                return -1;
              }
              if (b.expiration_date == null) {
                return 1;
              }
            }
            if (a.expiration_date != null && b.expiration_date != null) {
              if (a.expiration_date > b.expiration_date) {
                return 1;
              }
              if (b.expiration_date > a.expiration_date) {
                return -1;
              }
            }
            return 0;
          });

          if (e.lotes.length > 0 && e.stock[0].pivot.batch_control == 1) {
            if (parseFloat(e.lotes[0].amount) < 0) {
              adicionarLote(e.id, e.pivot.amount, "");
            } else {
              adicionarLote(e.id, e.pivot.amount, e.lotes[0].batch);
            }
          } else {
            adicionarLote(e.id, e.pivot.amount, "");
          }
        });

        dados.value.produtos = dados.value.produtos.map((value) => {
          return {
            ...value,
            stock:
              value.stock.length == 0 ? [{ batch_control: 0 }] : value.stock,
            grupoProduto: value.contracts?.[0]?.pivot?.product_group?.name,
          };
        });

        if (requisicaoDetalhes.value.status == "Finalizado") {
          const fichaDados = await store.dispatch("requisicao/fichaEPI", {
            voucher_id: requisicaoId,
          });

          dados.value.produtos = dados.value.produtos.map((produto) => {
            const produtoFichaEspecifico = fichaDados.data.return.data.find(
              (ficha) => {
                return produto.id == ficha.ItemId;
              }
            );
            return produtoFichaEspecifico == undefined
              ? produto
              : {
                  ...produto,
                  code: produtoFichaEspecifico.ItemCodigo,
                  pivot: {
                    user: { name: produtoFichaEspecifico.ItemNomeContrato },
                    product_id: produtoFichaEspecifico.ItemId,
                    amount:
                      Number(
                        produtoFichaEspecifico?.ItemQuantidade?.replace(
                          /\./g,
                          ""
                        ).replace(",", ".")
                      ) || 0,
                    new_amount:
                      Number(
                        produtoFichaEspecifico?.ItemQuantidade?.replace(
                          /\./g,
                          ""
                        ).replace(",", ".")
                      ) || 0,
                  },
                  name: produtoFichaEspecifico.ItemNomeContrato,
                  ca: produtoFichaEspecifico.ItemCaCodigo,
                  grupoProduto: produtoFichaEspecifico.ItemGrupoNome,
                  quantidade:
                    Number(
                      produtoFichaEspecifico?.ItemQuantidade?.replace(
                        /\./g,
                        ""
                      ).replace(",", ".")
                    ) || 0,
                };
          });
        }
      } catch (error) {
        console.log(error);
      }
      loading.value = false;
    };

    const atualizarValores = async () => {
      description.value = "";
      let products = [];
      requisicaoDetalhes.value.products.forEach((e) => {
        if (e.pivot.new_amount && e.pivot.amount != e.pivot.new_amount) {
          description.value += `${e.code} foi alterado de ${e.pivot.amount} para ${e.pivot.new_amount} - `;
          products.push({
            id: e.id,
            amount: e.pivot.new_amount.replace(/,/g, "."),
          });
        } else {
          products.push({
            id: e.id,
            amount: e.pivot.amount.replace(/,/g, "."),
          });
        }
      });
      try {
        await store.dispatch("requisicao/atualizarQuantidade", {
          voucher_id: requisicaoDetalhes.value.id,
          description: description.value,
          products: products,
        });
        quasar.notify({
          message: "Quantidade atualizada",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar quantidade",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reprovarRequisicao = async () => {
      try {
        await store.dispatch("requisicao/excluir", {
          reqId: requisicaoId,
        });
        quasar.notify({
          message: "Requisição reprovada",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "requisicao-lista" });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao reprovar requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
      usuarioVerificado.value = true;
      finalizarRequisicao();
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const userLogado = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      userLogadoId.value = response.data.id;
    };

    const finalizarRequisicao = async () => {
      let valido = true;
      dados.value.produtos.forEach((produto) => {
        if (produto.pivot.new_amount) {
          atualizarValores();
          valido = false;
        }
      });
      if (valido) {
        let batches = [];

        lotes.value.forEach((lote) => {
          const produto = dados.value.produtos.find(
            (p) => p.id === lote.productId
          );

          if (
            produto &&
            produto.stock[0]?.batch_control === 1 &&
            parseFloat(lote.amount) > 0 &&
            lote.batch !== ""
          ) {
            batches.push({
              batch: lote.batch,
              amount: lote.amount.replace(/,/g, "."),
              product_id: lote.productId,
            });
          }
        });

        if (
          tipoAssinatura.value != "token" &&
          !imagemBase64.value &&
          imagemBase64.value == undefined
        ) {
          quasar.notify({
            message:
              "É necessário usar um metodo de autenticação para a finalização.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        if (!usuarioVerificado.value && tipoAssinatura.value != "facial") {
          quasar.notify({
            message: "A Biometria coletada não coincide com a do solicitante",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        botaoFinalizacao.value = true;
        try {
          await store.dispatch("requisicao/finalizar", {
            reqId: requisicaoId,
            imagemBase64:
              tipoAssinatura.value != "token"
                ? imagemBase64.value
                : store.state.autenticacao.token,
            idUsuario:
              dados.value.solicitante && dados.value.solicitante.id
                ? dados.value.solicitante.id
                : dados.value.solicitanteId,
            date:
              dados.value.dataRetroativa != null
                ? converterData(dados.value.dataRetroativa)
                : gerarTimestamp(),
            batches: batches,
            mensagem: mensagemFase.value,
            auth_type: tipoAssinatura.value,
          });
          enviarImageBiometria();
          quasar.notify({
            message: "Requisição finalizada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          router.push({ name: "requisicao-lista" });
          botaoFinalizacao.value = false;
        } catch (error) {
          quasar.notify({
            message: error.response.data.message,
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          botaoFinalizacao.value = false;
        }
      }
    };

    const adicionarLote = async (id, quantidade, nome) => {
      batchsName.value = nome;
      batchsQuantidade.value = quantidade.replace(/,/g, ".");
      lotes.value.push({
        batch: batchsName.value,
        amount: batchsQuantidade.value,
        id: nextId.value,
        productId: id,
      });
      batchsName.value = "";
      batchsQuantidade.value = 0;
      nextId.value++;
    };

    const enviarImageBiometria = async () => {
      try {
        await store.dispatch("requisicao/enviarImageBiometria", {
          voucher_id: requisicaoId,
          image: imagemBase64.value,
        });
      } catch (error) {
        console.log(error);
      }
    };

    const removerLote = (index) => {
      lotes.value.splice(index, 1);
    };

    //Ordem de serviço

    const listarOrdem = async (value) => {
      try {
        const response = await store.dispatch("requisicao/listarOrdem", {
          per_page: 10,
          numero: value,
        });

        listaOrdem.value = response.data.data;
      } catch (error) {
        console.log(error);
      }
    };

    //Solicitante

    //Ordem de serviço

    const listarSolicitante = async (value) => {
      try {
        const response = await store.dispatch("requisicao/listarSolicitante", {
          per_page: 10,
          search: value,
        });

        listaSolicitante.value = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const converterData = (data) => {
      let partesData = data.split("/");

      const agora = new Date();

      let dataObjeto = new Date(
        partesData[2],
        partesData[1] - 1,
        partesData[0],
        agora.getHours(),
        agora.getMinutes(),
        agora.getSeconds()
      );

      // Formata manualmente com horário local
      const ano = dataObjeto.getFullYear();
      const mes = (dataObjeto.getMonth() + 1).toString().padStart(2, "0");
      const dia = dataObjeto.getDate().toString().padStart(2, "0");
      const horas = dataObjeto.getHours().toString().padStart(2, "0");
      const minutos = dataObjeto.getMinutes().toString().padStart(2, "0");
      const segundos = dataObjeto.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    };

    const setOrdem = async () => {
      try {
        await store.dispatch("requisicao/escolherOrdem", {
          voucher_id: requisicaoId,
          osid: dados.value.ordem.uuid,
        });
        quasar.notify({
          message: "Ordem Adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar Ordem",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerOrdem = async () => {
      try {
        await store.dispatch("requisicao/removerOrdem", {
          voucher_id: requisicaoId,
          osid: dados.value.ordem.uuid,
        });

        quasar.notify({
          message: "Ordem removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalheRequisicao();
      } catch (error) {
        quasar.notify({
          message: "Erro ao adicionar Ordem",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarCancelamentoPacial = async (resultado) => {
      if (resultado) {
        confirmacaoCanelamentoParcial.value = false;
        try {
          await store.dispatch("requisicao/cancelarParcial", {
            voucher_id: requisicaoId,
            products: selectedTrocaProdutoCancelarParcial.value,
          });

          quasar.notify({
            message: "Ordem removida com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          detalheRequisicao();
          selectedTrocaProdutoCancelarParcial.value = [];
          cancelarPacialOpen.value = false;
        } catch (error) {
          quasar.notify({
            message: "Erro ao adicionar Ordem",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } else {
        confirmacaoCanelamentoParcial.value = false;
      }
    };

    const editarQuantidade = (id, quantidade) => {
      lotes.value.forEach((e) => {
        if (id == e.id) {
          e.amount = quantidade;
        }
      });
    };

    const editarNomeLote = (id, nome) => {
      lotes.value.forEach((e) => {
        if (id == e.id) {
          e.batch = nome;
        }
      });
    };

    const options = (produtoId, controle) => {
      let options = [];

      dados.value.produtos.forEach((e) => {
        if (e.id == produtoId) {
          e.lotes.forEach((lote) => {
            if (parseFloat(lote.amount) > 0) {
              if (controle == 1) {
                setDefaultValue(lote);
              }

              options.push(lote.batch);
            }
          });
        }
      });
      return options;
    };

    const setDefaultValue = async (lote) => {
      if (lotes.value[0].batch != "") {
        return;
      } else {
        lotes.value[0].batch =
          parseFloat(lote.amount) >= parseFloat(lotes.value[0].amount)
            ? lote.batch
            : lotes.value[0].batch;
      }
    };

    const aprovar = async () => {
      botaoFinalizacao.value = true;
      try {
        await store.dispatch("requisicao/aprovar", {
          reqId: requisicaoId,
        });
        botaoFinalizacao.value = false;
        router.push({ name: "requisicao-lista" });
        quasar.notify({
          message: "Requisição aprovada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao aprovar requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        botaoFinalizacao.value = false;
        console.log(error);
      }
    };

    const arquivos = async () => {
      router.push({ name: "requisicao-arquivos", params: requisicaoId });
    };

    const verificaArquivoUpload = async () => {
      try {
        let response = await store.dispatch("requisicao/listarDocumentos", {
          voucher_id: requisicaoId,
        });
        let array = response.data.result;

        if (array.length > 0) {
          uploadArquivo.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const tipoFinalizacao = async () => {
      const roles =
        store.state.autenticacao.usuarioLogado.permissoes.gmapi?.roles || [];
      const temPermissaoAnexo = roles.some(
        (r) => r.trim().normalize("NFC") === "upload_arquivo_requisição"
      );

      if (temPermissaoAnexo) {
        try {
          const responseArquivos = await store.dispatch(
            "requisicao/listarDocumentos",
            { voucher_id: requisicaoId }
          );
          const arquivosAnexados = responseArquivos.data.result;
          if (!arquivosAnexados || arquivosAnexados.length === 0) {
            quasar.notify({
              message:
                "É obrigatório anexar ao menos um arquivo antes de finalizar a requisição.",
              color: "negative",
              actions: [{ label: "Fechar", color: "white" }],
            });
            return;
          }
        } catch (error) {
          return;
        }
      }

      if (
        !dados.value.dataRetroativa ||
        dados.value.dataRetroativa.trim() === ""
      ) {
        dataRetroativaErro.value = "Informe a data de retirada";
        return;
      }

      if (
        tipoAssinatura.value == "biometria" ||
        tipoAssinatura.value == "token" ||
        tipoAssinatura.value == "facial"
      ) {
        finalizarRequisicao();
        return;
      }
      if (tipoAssinatura.value == "web_pin") {
        verificarPin();
        return;
      }
      salvarAssinatura.value++;
    };

    const verificarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo de pin não pode ser vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id:
            dados.value.solicitante && dados.value.solicitante.id
              ? dados.value.solicitante.id
              : dados.value.solicitanteId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message:
              "Senha Validada com Sucesso, a requisição será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          imagemBase64.value = pin.value;
          usuarioVerificado.value = true;
          finalizarRequisicao();
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        detalheRequisicao();
      } catch (error) {
        console.log(error);
      }
    };

    const gerarTimestamp = () => {
      const dataAtual = new Date();

      const ano = dataAtual.getFullYear();
      const mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      const dia = dataAtual.getDate().toString().padStart(2, "0");
      const horas = dataAtual.getHours().toString().padStart(2, "0");
      const minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      const segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      const timestamp = `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;

      return timestamp;
    };
    const retornarValorEstoque = (value) => {
      let estoque = value.filter(
        (value) => value.vendor_id === objetoUnidade.value.id
      );
      if (estoque.length > 0) {
        return parseFloat(estoque[0].amount).toFixed(2);
      }
    };

    const criarTransferencia = async () => {
      if (requisicaoDetalhes.value.status != "Finalizado") {
        quasar.notify({
          message:
            "Só é possivel criar uma transferencia no status 'finalizado'.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        unidadeTransferencia.value?.id === undefined ||
        unidadeTransferencia.value?.id === ""
      ) {
        quasar.notify({
          message: "Escolha a unidade de destino.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        requisicaoDetalhes.value.vendor.id == unidadeTransferencia.value?.id
      ) {
        quasar.notify({
          message: "A unidade de destino não pode ser igual a origem.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/criarTransferencia", {
          deposito_id_entrada: unidadeTransferencia.value?.id,
          deposito_id_saida: requisicaoDetalhes.value.vendor.id,
          descricao: `Transferência criada a partir da requisição de número ${requisicaoId}.`,
          solicitante_id: dados.value.solicitanteId,
          transferir_estoque: 0,
        });
        quasar.notify({
          message: "Transferência criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        adicionarProdutoTransferencia(response.data.result.id);
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarProdutoTransferencia = async (id_transferencia) => {
      let produtos = [];
      if (requisicaoDetalhes.value.products.length > 0) {
        requisicaoDetalhes.value.products.forEach((produto) => {
          produtos.push({
            id: produto.id,
            quantidade: produto.pivot.amount,
          });
        });
      }
      try {
        await store.dispatch("transferencia/adicionarProduto", {
          id_transferencia,
          action: "adicionar-produto",
          transferir_estoque: 0,
          produtos,
        });
        router.push({
          name: "transferencia-detalhe",
          params: { transferenciaId: id_transferencia },
        });
        quasar.notify({
          message:
            "Produtos adicionados na transferência com sucesso. Você será redirecionado para detalhe.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message:
            "Erro ao adicionar produtos, você precisará fazer isso manualmente. Você será redirecionado a transferência criada.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "transferencia-detalhe",
          params: { transferenciaId: id_transferencia },
        });
      }
    };

    watch(
      () => tipoAssinatura.value,
      () => {
        if (tipoAssinatura.value == "token") {
          usuarioVerificado.value = true;
          imagemBase64.value = null;
          pin.value = "";
          return;
        }
        imagemBase64.value = null;
        pin.value = "";
        usuarioVerificado.value = false;
      }
    );

    const validacaoTenent = async () => {
      const subdomain = window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : "";

      assinaturaDesabilitado.value.forEach((e) => {
        if (subdomain.indexOf(e) != -1) {
          assinaturaDesabilitadoVariable.value = false;
          tipoAssinatura.value = "biometria";
        }
      });
    };

    const receberUnidadeTransferencia = (value) => {
      unidadeTransferencia.value = value;
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      imagemBase64.value = faceImage;
      facial.value = false;

      quasar.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const receberFaceCadastro = async () => {
      facial.value = false;

      quasar.notify({
        message: "Face cadastrada com sucesso! Agora você pode coletar a face.",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const atualizarTemplatesFacial = async () => {
      try {
        if (requisicaoDetalhes.value.plantiff) {
          requisicaoDetalhes.value.plantiff.biometria_facial = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => dados.value.ordem,
      () => {
        if (requisicaoDetalhes.value.os == dados.value.ordem) {
          return;
        }
        setOrdem();
      }
    );

    const getProdutosTroca = async () => {
      grupoTrocaList.value = [];
      loading.value = true;
      try {
        const response = await store.dispatch("requisicao/produtosTroca", {
          group_id: grupoIdTroca.value,
          contract_id: store.state.org.contract,
        });
        grupoTrocaList.value = response.data.model.products.data;
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };

    const enviar = async (resultado) => {
      confirmacao.value = false;

      try {
        if (resultado) {
          trocarItemModal.value = false;

          await store.dispatch("requisicao/produtosTrocaConcluir", {
            requisicao_id: requisicaoId,
            produtos: [
              {
                id_entrada: selectedTrocaProduto.value.id,
                id_saida: produtoIdTroca.value.id,
              },
            ],
          });
          quasar.notify({
            message: "Troca realizada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          detalheRequisicao();
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao fazer a troca",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const abrirModalHistorico = () => {
      modalHistoricoAberto.value = true;
    };

    const formatarDataAtual = () => {
      const data = new Date();
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const ano = data.getFullYear();
      return `${dia}/${mes}/${ano}`;
    };

    watch(
      () => selectedTrocaProduto.value,
      () => {
        confirmacao.value = true;
      }
    );

    watch(
      () => grupoIdTroca.value,
      () => {
        if (trocarItemModal.value) {
          getProdutosTroca();
        }
      }
    );

    //Trava para impedir datas futuras na Data Retirada
    watch(
      () => dados.value.dataRetroativa,
      (novaData) => {
        validateDataRetroativa(novaData);
      }
    );

    //Funcao para deixar datas futuras opacas no calendario
    const dataPermitida = (dateStr) => {
      const [ano, mes, dia] = dateStr.split("/").map(Number);
      const data = new Date(ano, mes - 1, dia, 0, 0, 0, 0);
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return data <= hoje;
    };

    onMounted(detalheRequisicao);
    onMounted(userLogado);
    onMounted(verificaArquivoUpload);
    onMounted(validacaoTenent);

    return {
      columns,
      columns2,
      dados,
      detalheRequisicao,
      requisicaoId,
      adicionarProdutoTransferencia,
      requisicaoDetalhes,
      tipoAssinatura,
      atualizarValores,
      enviar,
      fecharFacial,
      confirmacao,
      receberFace,
      receberFaceCadastro,
      atualizarTemplatesFacial,
      description,
      loading,
      criarTransferencia,
      reprovarRequisicao,
      finalizarRequisicao,
      imagemBase64,
      mensagemFase,
      userLogado,
      recebeAssinatura,
      retornarValorEstoque,
      salvarAssinatura,
      adicionarLote,
      lotes,
      batchsName,
      objetoUnidade,
      batchsQuantidade,
      nextId,
      removerLote,
      options,
      editarQuantidade,
      aprovar,
      arquivos,
      verificaArquivoUpload,
      uploadArquivo,
      cancelarPacialOpen,
      editarNomeLote,
      receberUnidadeTransferencia,
      verificarBiometria,
      userLogadoId,
      enviarImageBiometria,
      recebeBiometria,
      tipoFinalizacao,
      pin,
      verificarPin,
      receberResultadoBiometria,
      unidadeTransferencia,
      usuarioVerificado,
      converterData,
      atualizarTemplatesBiometria,
      confirm,
      gerarTimestamp,
      mobile,
      atualizarHistorico,
      userLogadoQuery,
      item,
      assinaturaDesabilitadoVariable,
      setDefaultValue,
      listaOrdem,
      listaSolicitante,
      rightDrawerOpen,
      informarDataRetroativa,
      trocarItemModal,
      grupoIdTroca,
      produtoIdTroca,
      grupoTrocaList,
      selectedTrocaProduto,
      selectedTrocaProdutoCancelarParcial,
      columnsCancelarParcial,
      confirmacaoCanelamentoParcial,
      enviarCancelamentoPacial,
      dataPermitida,
      showTooltip,
      modalHistoricoAberto,
      historicoObservacoes,
      abrirModalHistorico,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filterOrdem(val, update) {
        clearTimeout(time.value);
        time.value = setTimeout(() => {
          listarOrdem(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1000);
      },
      filterSolicitante(val, update) {
        clearTimeout(time.value);
        time.value = setTimeout(() => {
          listarSolicitante(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1000);
      },

      setOrdem,
      removerOrdem,
      facial,
      botaoFinalizacao,
      dataRetroativaErro,
      validateDataRetroativa,
    };
  },
};
</script>

<style scoped>
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
a {
  text-decoration: none;
}
input[type="file"] {
  display: none;
}
.btn-adicionar {
  display: inline-block;
  background-color: #58afc1;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
}
.text {
  display: inline;
}
ul {
  list-style: none;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: 37px;
  left: 9px;
}
.icon-voltar {
  font-size: 24px;
}
.observacao-container {
  width: 60%;
}
.img-container {
  border: 2px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 50px;
  height: 50px;
}
.img-normal {
  max-width: 100%;
  height: 100%;
}
.botao-imprimir {
  margin-top: 22px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal-excluir {
  width: 590px;
}

.align {
  align-items: center;
}

.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.custom-table td:nth-child(4) {
  position: relative;
  left: -10px;
}
.relative-position {
  position: relative;
}
.absolute-full {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  z-index: 1;
}
@media only screen and (max-width: 635px) {
  .container-titulo-principal {
    margin-top: 10px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-pagina-principal {
    font-size: 14px;
  }
  .icon-voltar {
    font-size: 15px;
    margin-top: 8px !important;
    margin-right: 7px;
  }
  .container-inputs {
    margin: 0 0 0 0;
  }
  .titulo-inputs {
    font-size: 12px;
    margin: 0px;
  }
  .input-font {
    font-size: 11px;
  }
  .titulo-tabela {
    margin: 30px 0px 0px 0px;
  }
  .texto-titulo-tabela {
    margin-left: 9px;
    font-size: 14px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
  .input-grid {
    width: 10px;
  }
  .numero {
    color: #fff;
  }
  .card-img {
    border: 1px solid #707070;
    border-radius: 5px;
    height: 80px;
  }
  .input-quantidade-container {
    margin-bottom: 29px;
  }
  .input-quantidade {
    font-size: 14px;
    width: 26px;
    height: 12px;
    padding-left: 5px;
  }
  .observacao-container {
    width: 100%;
  }
  .container-observacao-row {
    width: 100%;
    margin: 30px 0 0 0;
    padding: 0px;
  }
  .sub-text {
    font-size: 12px;
    opacity: 0.8;
  }
  .btn {
    font-size: 12px !important;
    margin-top: 8px;
  }
  .container-assinatura-responsiva {
    margin: 30px 0px 0px 0px;
  }
  .canvas-container {
    width: 100%;
  }
  .container-btn-arquivo {
    margin: 30px 0px 40px 5px;
  }
  .btn-adicionar {
    background-color: #58afc1;
    cursor: pointer;
    margin: 5px 5px 0 0;
    padding: 4px 20px;
    padding-left: 40px;
    font-size: 12px;
  }
  .icon {
    position: absolute;
    top: 35px;
    left: 9px;
  }
  .btn-enviar-container {
    margin: 0px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .input-lote-nome {
    width: 100px;
    font-size: 11px;
  }
  .input-lote-qtd {
    width: 80px;
    margin-left: 5px;
    font-size: 11px;
  }
  .btn-delete {
    font-size: 11px;
    margin: 0px;
    padding: 0px 0px 0px 5px;
  }
  .text-campos-lotes {
    font-size: 12px;
    margin: 0px 4px;
  }
  .text-lotes-existentes {
    font-size: 11px;
  }
  .botao-imprimir {
    margin-top: 19px;
  }
  .btn-modal {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
@media only screen and (max-width: 387px) {
  .input-lote-nome {
    width: 100px;
    font-size: 11px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
@media only screen and (max-width: 370px) {
  .input-lote-nome {
    width: 90px;
    font-size: 11px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .btn {
    font-size: 10px !important;
  }
  .input-lote-qtd {
    width: 60px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>

<style>
.quantidade-input-requisicao .q-field__control:before {
  border-color: red !important;
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
